import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IRequestForInfrastructureRespond } from '@/shared/model/request-for-infrastructure-respond.model';

const baseApiUrl = 'api/request-for-infrastructure-responds';

export default class RequestForInfrastructureRespondService {
  public find(id: number): Promise<IRequestForInfrastructureRespond> {
    return new Promise<IRequestForInfrastructureRespond>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findForInfrastructure(infrastructureId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + '/find-for-infrastructure/' + `${infrastructureId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IRequestForInfrastructureRespond): Promise<IRequestForInfrastructureRespond> {
    return new Promise<IRequestForInfrastructureRespond>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IRequestForInfrastructureRespond): Promise<IRequestForInfrastructureRespond> {
    return new Promise<IRequestForInfrastructureRespond>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
